import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import { ThemeProvider } from "./context/ThemeContext";
import { Toaster } from "./components/ui/sonner";

import Landing from "./pages/Landing";
import CustomerLogin from "./pages/CustomerLogin";
import AdminLogin from "./pages/AdminLogin";
import CustomerMenu from "./pages/CustomerMenu";
import CustomerCart from "./pages/CustomerCart";
import OrderSuccess from "./pages/OrderSuccess";
import OrderVault from "./pages/OrderVault";
import StaffDashboard from "./pages/StaffDashboard";
import OwnerDashboard from "./pages/OwnerDashboard";
import PlatformAdmin from "./pages/PlatformAdmin";

function RoleRoute({ roles, children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-white/50">Loading…</div>;
  if (!user) return <Navigate to="/login/admin" replace />;
  if (!roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function CustomerRoute({ children }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-white/50">Loading…</div>;
  if (!user || user.role !== "customer") {
    // Preserve the intended URL so CustomerLogin can route the guest back after OTP
    return <Navigate to="/login/customer" state={{ from: loc.pathname + loc.search }} replace />;
  }
  return children;
}

export default function App() {
  return (
    <div className="App min-h-screen" style={{ background: "var(--bg)", color: "var(--fg)" }}>
      <ThemeProvider>
        <AuthProvider>
          <CartProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/login/customer" element={<CustomerLogin />} />
                <Route path="/login/admin" element={<AdminLogin />} />

                <Route path="/r/:slug" element={<CustomerMenu />} />
                <Route path="/r/:slug/t/:tableNo" element={<CustomerMenu />} />
                <Route path="/r/:slug/cart" element={<CustomerRoute><CustomerCart /></CustomerRoute>} />
                <Route path="/r/:slug/order/:oid/success" element={<CustomerRoute><OrderSuccess /></CustomerRoute>} />
                <Route path="/r/:slug/vault" element={<CustomerRoute><OrderVault /></CustomerRoute>} />

                <Route path="/staff" element={<RoleRoute roles={["staff", "owner"]}><StaffDashboard /></RoleRoute>} />
                <Route path="/owner" element={<RoleRoute roles={["owner"]}><OwnerDashboard /></RoleRoute>} />
                <Route path="/platform" element={<RoleRoute roles={["super_admin"]}><PlatformAdmin /></RoleRoute>} />

                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </BrowserRouter>
            <Toaster theme="dark" position="top-center" />
          </CartProvider>
        </AuthProvider>
      </ThemeProvider>
    </div>
  );
}
